import React from 'react';
import {createRoot} from 'react-dom/client';
import {HashRouter, Routes, Route} from 'react-router';
import { getInitColorSchemeScript } from '@mui/joy/styles';
import '@fontsource/inter';

import './index.css';
import AppLayout from './root';
import App from './app';
import Profile from './profile';
import AddTicker from './addTicker';
import ShowStock from './showstock';
import ChooseStops from './choosestops';
import ShowStops from './showstops';
import ErrorPage from "./errorpage";
import Login from "./login";
import { CssVarsProvider }				from '@mui/joy/styles';
import CssBaseline 						from '@mui/joy/CssBaseline';
import GlobalStyles 					from '@mui/joy/GlobalStyles';

import {config} from "./config.js";

const root = createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
  		{getInitColorSchemeScript()}
	    <CssVarsProvider defaultMode="dark" modeStorageKey="joy-mode-scheme-dark">
	    
			<CssBaseline />
			<GlobalStyles styles={{body: { backgroundColor: config.bgColor }}}/>

			<HashRouter>
				<Routes>
					<Route path="/" element={<AppLayout />}>
						<Route index element={<App />} />
						<Route path="login" element={<Login />} />
						<Route path="addticker" element={<AddTicker />} />
						<Route path="showstock" element={<ShowStock />} />
						<Route path="setstop" element={<ChooseStops />} />
						<Route path="showstops" element={<ShowStops />} />
						<Route path="profile" element={<Profile />} />
						<Route path="error" element={<ErrorPage />} />
						<Route path="*" element={<ErrorPage />} />
					</Route>
				</Routes>	
			</HashRouter>
			
		</CssVarsProvider>			
  	</React.StrictMode>
);